/**
 * Aplica el tema elegido al documento.
 *
 * `sistema` no estampa nada y deja que `prefers-color-scheme` decida; una
 * elección explícita estampa `data-tema` en la raíz y gana sobre el sistema.
 * El tema es local y no se sincroniza: oscuro en el teléfono y claro en la PC
 * es un caso legítimo.
 */

import { useEffect } from 'react';
import type { Tema } from '../domain/modelo/ajustes';

export function useTema(tema: Tema | undefined) {
  useEffect(() => {
    const raiz = document.documentElement;
    if (!tema || tema === 'sistema') raiz.removeAttribute('data-tema');
    else raiz.setAttribute('data-tema', tema);
  }, [tema]);
}
